/* eslint-disable no-use-before-define */
import { Component } from 'react';
import UrlShortenerItem from '../../Contents/UrlShortenerAdmin/UrlShortenerItem';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import UrlShortenerService from '../../Services/UrlShortenerService';

class EditUrlShortenerWindowDescription extends Component {
  static titleForCreate = 'Create New Short URL';
  static titleForEdit = 'Edit Short URL';
  static ComponentName = 'ShortUrl';

  static itemType = UrlShortenerItem;
  static serviceFunction = (edited) => UrlShortenerService.EditShortUrl(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ShortUrlString',
          label: 'Short Url (If not given, it will be generated automatically)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 50),
        },
        {
          fieldName: 'Target',
          label: 'Target*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredUrlTextField,
        },
        {
          fieldName: 'CreateStats',
          label: 'Create Stats',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active?',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'ExpirationDateUtc',
          label: 'Expiration Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'DeleteAfterExpirationDate',
          label: 'Delete After Expiration Date',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Notes',
          label: 'Notes',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 2000),
        },
        {
          fieldName: 'Tags',
          label: 'Tags',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default EditUrlShortenerWindowDescription;
